<!DOCTYPE html>
<html>

<head>
	<meta name="viewport" content="width=device-width, initial-scale=1.0">
	<style>
		* {
			box-sizing: border-box;
		}

		.row::after {
			content: "";
			clear: both;
			display: table;
		}

		[class*="col-"] {
			float: left;
			padding: 15px;
		}

		html {
			font-family: "Lucida Sans", sans-serif;
		}

		.header {
			background-color: #9933cc;
			color: #ffffff;
			padding: 15px;
		}

		.menu ul {
			list-style-type: none;
			margin: 0;
			padding: 0;
		}

		.menu li {
			padding: 8px;
			margin-bottom: 7px;
			background-color: #33b5e5;
			color: #ffffff;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
		}

		.menu li:hover {
			background-color: #0099cc;
		}

		.aside {
			background-color: #33b5e5;
			padding: 15px;
			color: #ffffff;
			text-align: center;
			font-size: 14px;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
		}

		.footer {
			background-color: #0099cc;
			color: #ffffff;
			text-align: center;
			font-size: 12px;
			padding: 15px;
		}

		/* For mobile phones: */
		[class*="col-"] {
			width: 100%;
		}

		@media only screen and (min-width: 600px) {

			/* For tablets: */
			.col-s-1 {
				width: 8.33%;
			}

			.col-s-2 {
				width: 16.66%;
			}

			.col-s-3 {
				width: 25%;
			}

			.col-s-4 {
				width: 33.33%;
			}

			.col-s-5 {
				width: 41.66%;
			}

			.col-s-6 {
				width: 50%;
			}

			.col-s-7 {
				width: 58.33%;
			}

			.col-s-8 {
				width: 66.66%;
			}

			.col-s-9 {
				width: 75%;
			}

			.col-s-10 {
				width: 83.33%;
			}

			.col-s-11 {
				width: 91.66%;
			}

			.col-s-12 {
				width: 100%;
			}
		}

		@media only screen and (min-width: 768px) {

			/* For desktop: */
			.col-1 {
				width: 8.33%;
			}

			.col-2 {
				width: 16.66%;
			}

			.col-3 {
				width: 25%;
			}

			.col-4 {
				width: 33.33%;
			}

			.col-5 {
				width: 41.66%;
			}

			.col-6 {
				width: 50%;
			}

			.col-7 {
				width: 58.33%;
			}

			.col-8 {
				width: 66.66%;
			}

			.col-9 {
				width: 75%;
			}

			.col-10 {
				width: 83.33%;
			}

			.col-11 {
				width: 91.66%;
			}

			.col-12 {
				width: 100%;
			}
		}
	</style>
</head>

<body>

	<div class="header">
		<h1>Schedule</h1>
	</div>

	<div class="row">
		<div class="col-3 col-s-3 menu">
			<label class="custom-control-label" for="isWebinar">Webinar</label>
			<input type="radio" class="custom-control-input" id="isWebinar" value="isWebinar" name="eventType" mdbInput
				(change)="onEventTypeChange($event.target.value)">

		</div>

		<div class="col-3 col-s-3">
			<label class="custom-control-label" for="isMeeting">Meeting</label>
			<input type="radio" class="custom-control-input" id="isMeeting" value="isMeeting" name="eventType" checked
				mdbInput (change)="onEventTypeChange($event.target.value)">
		</div>

	</div>

	<div class="row">
		<div class="col-3 col-s-3 menu">
			<label class="custom-control-label" for="isLive">Live</label>
			<input type="radio" class="custom-control-input" id="isLive" value="isLive" name="webinarType" checked mdbInput
				(change)="onWebinarTypeChange($event.target.value)">

		</div>

		<div class="col-3 col-s-3">
			<label class="custom-control-label" for="isRecorded">Recorded</label>
			<input type="radio" class="custom-control-input" id="isRecorded" value="isRecorded" name="webinarType" 
				mdbInput (change)="onWebinarTypeChange($event.target.value)">
		</div>

	</div>

	<div class="row" *ngIf="isShownRecordedDetails">
		<div class="col-3 col-s-3 menu">
			<input type="file" id="image" (change)="onFileSelected($event)">

		</div>

		

	</div>

	<div class="row">
		<div class="col-3 col-s-3">
			<label class="custom-control-label" for="isMeeting">Title</label>
			<input type="text" name="eventTitle" placeholder="Title" [(ngModel)]="eventTitle" />
		</div>


	</div>
	<div class="row" *ngIf="isShownMeetingDetails">

		<div class="col-6 col-s-6">
			<fieldset>
				<legend>Your Meetings Details:</legend>
				<div class="row">

					<div class="col-3 col-s-3">
						<label class="custom-control-label" for="randomIDs">Meeting Id </label>
						<input type="text" name="randomIDs" placeholder="meetingID" [(ngModel)]="randomIDs" />
					</div>
					<div class="col-3 col-s-3">
						<label class="custom-control-label" for="randomPasswords">Meeting Password </label>
						<input type="text" name="randomPasswords" placeholder="Password"
							[(ngModel)]="randomPasswords" />

					</div>

				</div>
			</fieldset>
		</div>
	</div>
	<div class="row">
		<div class="col-3 col-s-3 menu">
			<!-- Default unchecked -->
			<div class="custom-control custom-radio">
				<input type="radio" class="custom-control-input" id="isGroup" value="isGroup" name="userstypes" mdbInput
					(change)="onUserTypeChange($event.target.value)">
				<label class="custom-control-label" for="isGroup">Groups</label>
			</div>
		</div>
		<div class="col-3 col-s-3 menu">
			<!-- Default checked -->
			<div class="custom-control custom-radio">
				<input type="radio" class="custom-control-input" id="isOrganization" value="isOrganization"
					name="userstypes" checked mdbInput (change)="onUserTypeChange($event.target.value)">
				<label class="custom-control-label" for="isOrganization">Organization</label>
			</div>
		</div>
	</div>
	<div class="row" *ngIf="isShownModuleDetails">
		<div class="col-6 col-s-6 menu">
			<!-- Default unchecked -->
			<fieldset>
				<legend>Select Module:</legend>
				<div class="row">
					<div class="col-3 col-s-3 menu">
						<div class="custom-control custom-radio">
							<input type="radio" class="custom-control-input" id="isERP" value="isERP"
								name="OrganizationModule" mdbInput (change)="onModuleTypeChange($event.target.value)">
							<label class="custom-control-label" for="isERP">ERP</label>
						</div>
					</div>
					<div class="col-3 col-s-3 menu">
						<div class="custom-control custom-radio">
							<input type="radio" class="custom-control-input" id="isSMS" value="isSMS"
								name="OrganizationModule" checked mdbInput
								(change)="onModuleTypeChange($event.target.value)">
							<label class="custom-control-label" for="isSMS">SMS</label>
						</div>

					</div>
				</div>
			</fieldset>

		</div>
	</div>


	<div class="row" *ngIf="isShownGroupDetails">
		<div class="col-6 col-s-6 menu">
			<!-- Default unchecked -->
			<fieldset>
				<legend>Select Group:</legend>
				<div class="row">
					<div class="col-3 col-s-3 menu">
						<div class="custom-control custom-radio">

							<select id="group" [(ngModel)]="group" (change)="getAllGroupMemberList();">
								<option [ngValue]='0'>SELECT</option>
								<option *ngFor="let order of groupList;" [value]="order.groupId">
									{{order.groupName}}
								</option>
							</select>


						</div>
					</div>
					<div class="col-3 col-s-3 menu">
						<div class="custom-control custom-radio">

							<select id="groupMemebr" [(ngModel)]="groupMemebr" (change)="setTakebyID(groupMemebr);">
								<option [ngValue]='0'>SELECT</option>
								<option *ngFor="let order of groupMemberList;" [value]="order.userId">
									{{order.name}}
								</option>
							</select>


						</div>
					</div>
				</div>
			</fieldset>

		</div>
	</div>




	<div class="row" *ngIf="isShownERPDetails">
		<fieldset>
			<legend>Select Users:</legend>
			<div class="row">
				<div class="col-3 col-s-3 menu">
					<div class="custom-control custom-radio">
						<label for="department">Department</label>
						<select id="department" [(ngModel)]="department" (change)="getAllUsersList()">
							<option [ngValue]='0'>SELECT</option>
							<option *ngFor="let order of departmentsList;" [value]="order.id">
								{{order.deptName}}
							</option>
						</select>
					</div>
				</div>
				<div class="col-3 col-s-3 menu">
					<div class="custom-control custom-radio">
						<label for="duser">Users</label>
						<select id="duser" [(ngModel)]="dUser" (change)="setTakebyID(dUser);">
							<option [ngValue]='0'>SELECT</option>
							<option *ngFor="let order of usersList;" [value]="order.empID">
								{{order.empName}}
							</option>
						</select>
					</div>
				</div>
			</div>
		</fieldset>
	</div>
	<div class="row" *ngIf="isShownSMSDetails">

		<fieldset>
			<legend>Select Users:</legend>



			<div class="col-3 col-s-3 menu">
				<div class="custom-control custom-radio">
					<label for="course">Course</label>
					<select id="course" [(ngModel)]="course">
						<option [ngValue]='0'>SELECT</option>
						<option *ngFor="let order of courseList;" [value]="order.id">
							{{order.name}}
						</option>
					</select>
				</div>
			</div>
			<div class="col-3 col-s-3 menu">
				<div class="custom-control custom-radio">
					<label for="session">Session</label>
					<select id="session" [(ngModel)]="session" (change)="getAllStudentList();">
						<option [ngValue]='0'>SELECT</option>
						<option *ngFor="let order of sessionList;" [value]="order.id">
							{{order.session}}
						</option>
					</select>
				</div>
			</div>

			<div class="col-3 col-s-3 menu">
				<div class="custom-control custom-radio">
					<label for="faculty">Faculty</label>
					<select id="faculty" [(ngModel)]="takenBy" (change)="setTakebyID(takenBy);">
						<option [ngValue]='0'>SELECT</option>
						<option *ngFor="let order of facultyList;" [value]="order.id">

							{{order.name}}
						</option>
					</select>
				</div>
			</div>
			<div class="col-3 col-s-3 menu">
				<div class="custom-control custom-radio">
					<label for="student">Student</label>
					<select id="student">
						<option *ngFor="let order of studentList" [value]="order.id">
							{{order.name}}
						</option>
					</select>
				</div>
				<div>
				</div>

			</div>
		</fieldset>
	</div>
	<div class="row">
		<div class="col-3 col-s-3 menu">
			<div class="custom-control custom-radio">
				<label>Start Date</label>
				<input type="date" [(ngModel)]="startDate" required>
			</div>
			<div class="custom-control custom-radio">
				<label>Start Time</label>
				<input type="time" [(ngModel)]="startTime" required>
			</div>
		</div>
		<div class="col-3 col-s-3 menu">
			<div class="custom-control custom-radio">
				<label>End Date</label>
				<input type="date" [(ngModel)]="endDate" required>
			</div>
			<div class="custom-control custom-radio">
				<label>End Time</label>
				<input type="time" [(ngModel)]="endTime" required>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-3 col-s-3 menu">
			<input type="button" value="Create Event" (click)="createEvent()" />
		</div>
	</div>
	<div class="footer">

	</div>

</body>

</html>